import { render, staticRenderFns } from "./writeOffOpenCard.vue?vue&type=template&id=9f519dd4&scoped=true"
import script from "./writeOffOpenCard.vue?vue&type=script&lang=js"
export * from "./writeOffOpenCard.vue?vue&type=script&lang=js"
import style0 from "./writeOffOpenCard.vue?vue&type=style&index=0&id=9f519dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f519dd4",
  null
  
)

export default component.exports